<nb-card class="helix-popup-body">
  <nb-card-header>
    <div class="header-container">{{ title }}</div>
  </nb-card-header>
  <nb-card-body>
    <div class="container">
      <ngx-panzoom>
        <img *ngIf="imageUrl" [src]="imageUrl" alt="Network Map" />
      </ngx-panzoom>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button
      nbButton
      status="primary"
      ng-reflect-set-status="primary"
      class="btn-primary btn-outline btn-small"
      (click)="close()"
      i18n="@@process-model-close-button"
    >
      Close
    </button>
  </nb-card-footer>
</nb-card>
